export default __webpack_public_path__ + "static/media/photo--lg--matt-3.58113570.jpg";